/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "../../../components/MKBox";

// Images
import claudeLogo from "assets/images/emtay/claude_logo.png";
import codexLogo from "assets/images/emtay/codex_logo.png";
import openrouterLogo from "assets/images/emtay/openrouter_logo.png";
import vllmLogo from "assets/images/emtay/vllm_logo.png";

import styles from "assets/scss/emtay.module.scss";

import MKTypography from "../../../components/MKTypography";

// i18n
import { useLanguage } from "i18n";

function AgenticTools() {
  const { t } = useLanguage();
  const tools = [
    { name: "Claude", href: "https://claude.ai/", logo: claudeLogo },
    { name: "Codex", href: "https://openai.com/codex/", logo: codexLogo },
    { name: "OpenRouter", href: "https://openrouter.ai/", logo: openrouterLogo },
    { name: "vLLM", href: "https://vllm.ai/", logo: vllmLogo },
  ];

  return (
    <MKBox component="section" pt={3} pb={8} py={2}>
      <Container>
        <Grid
          container
          item
          xs={12}
          lg={8}
          justifyContent="center"
          alignItems="center"
          flexDirection="column"
          sx={{ mx: "auto", textAlign: "center" }}
        >
          <MKTypography variant="h4" my={1}>
            {t("agenticTools.title")}
          </MKTypography>
        </Grid>
        <Grid container spacing={1} justifyContent="center">
          {tools.map((tool) => (
            <Grid item xs={4} md={3} lg={3} key={tool.name}>
              <a href={tool.href} target="_blank" rel="noopener noreferrer">
                <div className={styles.technologiesBlock}>
                  <MKTypography variant="h6" my={1} className={styles.technologyTitle}>
                    {tool.name}
                  </MKTypography>
                  <MKBox
                    component="img"
                    src={tool.logo}
                    alt={tool.name}
                    className={styles.technologyLogo}
                    opacity={0.7}
                  />
                </div>
              </a>
            </Grid>
          ))}
        </Grid>
      </Container>
    </MKBox>
  );
}

export default AgenticTools;
